(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const form = document.getElementById('cart-form');
    if (!form) return;

    form.querySelectorAll('[data-qty-change]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = btn.closest('.cart-item__qty').querySelector('.cart-item__qty-input');
        const delta = parseInt(btn.dataset.qtyChange, 10);
        const next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = next;
        form.requestSubmit();
      });
    });

    form.querySelectorAll('.cart-item__qty-input').forEach((input) => {
      input.addEventListener('change', () => form.requestSubmit());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const hamburger = document.querySelector('.header__hamburger');
  const dialog    = document.getElementById('header-mobile-nav');
  const closeBtn  = dialog.querySelector('.mobile-nav__close');

  function openMenu() {
    dialog.showModal();
    hamburger.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    dialog.close();
    hamburger.setAttribute('aria-expanded', 'false');
  }

  hamburger.addEventListener('click', openMenu);
  closeBtn.addEventListener('click', closeMenu);

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) closeMenu();
  });

  dialog.addEventListener('close', () => {
    hamburger.setAttribute('aria-expanded', 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-collection"] && !Shopify.designMode) return;
  try {
    
  /* Movil: la vitrina arranca centrada en la obra del medio. */
  /* Se repite al cargar las imagenes: antes de eso la franja aun no
     tiene su ancho real. */
  (function () {
    function center() {
      document.querySelectorAll('.home-collection__showcase').forEach(function (el) {
        if (el.scrollWidth > el.clientWidth) {
          el.scrollLeft = (el.scrollWidth - el.clientWidth) / 2;
        }
      });
    }
    center();
    window.addEventListener('load', center);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-threshold"] && !Shopify.designMode) return;
  try {
    
  /* ── WebGL: stream de estrellas cayendo ── */
  (function() {
    var canvas = document.getElementById('threshold-canvas');
    if (!canvas) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      canvas.style.display = 'none';
      var heart = document.querySelector('.threshold__heart');
      if (heart) heart.removeAttribute('auto-rotate');
      return;
    }

    var P = {
      streamStartY: 0.0,   // dónde empieza el stream (0 = centro, negativo = más abajo)
      coneW:        0.10,  // ancho del cono al inicio   [0.03 – 0.30]
      coneTaper:    0.8,   // qué tan rápido se estrecha [0.3 – 2.0]
      fallFade:     2.2,   // desvanecimiento vertical   [1.0 – 4.0]
      fallSpeed:    0.18,  // velocidad de caída
      fallGrid:     19.0,  // densidad de estrellas
      freqBase:     0.25,  // vel. mínima de parpadeo
      freqRange:    0.25,  // variación de vel. entre estrellas
      gateExp:      10.0,  // brevedad del destello
      colorSpeed:   0.20,  // velocidad de cambio de color
      starSize:     70.0,  // tamaño del núcleo  [5 – 200]
      starBright:   4.0,   // intensidad del brillo [0.5 – 5.0]
    };

    function glf(n) { return Number.isInteger(n) ? n + '.0' : String(n); }

    var VERT = 'attribute vec2 pos; void main() { gl_Position = vec4(pos, 0.0, 1.0); }';

    var FRAG = `
      precision highp float;
      uniform vec2  iResolution;
      uniform float iTime;

      float hash(float n) { return fract(sin(n) * 43758.5453); }

      vec3 palette(float t) {
        vec3 a = vec3(0.600, 0.420, 0.480);
        vec3 b = vec3(0.420, 0.320, 0.420);
        vec3 c = vec3(1.000, 1.000, 0.800);
        vec3 d = vec3(0.000, 0.050, 0.560);
        return a + b * cos(6.28318 * (c * t + d));
      }

      void main() {
        vec2 uv = (gl_FragCoord.xy * 2.0 - iResolution.xy) / iResolution.y;

        float rawBelow  = ${glf(P.streamStartY)} - uv.y;
        float isBelow   = step(0.001, rawBelow);
        float belowDep  = max(rawBelow, 0.0);

        float coneW     = ${glf(P.coneW)} * exp(-belowDep * ${glf(P.coneTaper)});
        float coneMask  = exp(-uv.x * uv.x / max(coneW * coneW, 0.0001));
        float streamFade = exp(-belowDep * ${glf(P.fallFade)}) * coneMask * isBelow;

        vec2 fSUV  = vec2(uv.x, uv.y + iTime * ${glf(P.fallSpeed)});
        vec2 fCell = floor(fSUV * ${glf(P.fallGrid)});
        vec2 fLoc  = fract(fSUV * ${glf(P.fallGrid)}) - 0.5;

        float fh    = hash(fCell.x * 127.1 + fCell.y * 311.7);
        float fgate = pow(max(sin(iTime * (${glf(P.freqBase)} + fh * ${glf(P.freqRange)}) + fh * 6.2832), 0.0), ${glf(P.gateExp)});

        float fd   = length(fLoc);
        float fsh  = 300.0;
        float fsf  = 16.0;
        float fCore = exp(-fd * fd * ${glf(P.starSize)});
        float fSpH  = exp(-fLoc.y * fLoc.y * fsh) * exp(-abs(fLoc.x) * fsf);
        float fSpV  = exp(-fLoc.x * fLoc.x * fsh) * exp(-abs(fLoc.y) * fsf);
        float fLux  = fCore + (fSpH + fSpV) * 0.40;

        vec3 col = palette(fh + 0.35 + iTime * ${glf(P.colorSpeed)})
                 * fLux * fgate * streamFade * ${glf(P.starBright)};

        gl_FragColor = vec4(col, 1.0);
      }
    `;

    var gl = canvas.getContext('webgl', { antialias: false })
          || canvas.getContext('experimental-webgl', { antialias: false });

    if (!gl) return;

    function mkShader(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS))
        console.error('Shader error:', gl.getShaderInfoLog(s));
      return s;
    }

    var prog = gl.createProgram();
    gl.attachShader(prog, mkShader(gl.VERTEX_SHADER,   VERT));
    gl.attachShader(prog, mkShader(gl.FRAGMENT_SHADER, FRAG));
    gl.linkProgram(prog);
    gl.useProgram(prog);

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
      -1,-1,  1,-1,  -1, 1,
       1,-1,  1, 1,  -1, 1
    ]), gl.STATIC_DRAW);

    var posLoc = gl.getAttribLocation(prog, 'pos');
    gl.enableVertexAttribArray(posLoc);
    gl.vertexAttribPointer(posLoc, 2, gl.FLOAT, false, 0, 0);

    var uRes  = gl.getUniformLocation(prog, 'iResolution');
    var uTime = gl.getUniformLocation(prog, 'iTime');

    function resize() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width  = Math.round(canvas.offsetWidth  * dpr);
      canvas.height = Math.round(canvas.offsetHeight * dpr);
      gl.viewport(0, 0, canvas.width, canvas.height);
    }

    var t0 = performance.now();
    var rafId = null;
    var visible = true;

    function loop() {
      if (!visible) { rafId = null; return; }
      var t = (performance.now() - t0) * 0.001;
      gl.uniform2f(uRes,  canvas.width, canvas.height);
      gl.uniform1f(uTime, t);
      gl.drawArrays(gl.TRIANGLES, 0, 6);
      rafId = requestAnimationFrame(loop);
    }

    resize();
    window.addEventListener('resize', resize);

    /* Control externo: el fp-controller pausa esta animación cuando la
       sección 1 no está activa. Una capa WebGL repintando sin parar por
       encima del stack impide que la sección de abajo se componga. */
    window.__avThreshold = {
      pause:  function() { visible = false; },
      resume: function() { if (!visible) { visible = true; } if (!rafId) loop(); }
    };

    loop();
  })();

  /* ── Full-page scroll controller ── */
  (function() {
    var fpEls = document.querySelectorAll('[data-fp-section]');
    if (fpEls.length < 2) return;

    var wrappers = Array.from(fpEls).map(function(el) {
      return el.closest('.shopify-section') || el.parentElement;
    });

    var current      = 0;
    var isAnimating  = false;
    var lastNavigate = 0;
    var COOLDOWN     = 1200;
    var reduced      = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Overlay de niebla
    var overlay = document.createElement('div');
    overlay.className = 'fp-overlay';
    document.body.appendChild(overlay);

    // Preparar body y secciones
    document.body.classList.add('fp-mode');
    wrappers.forEach(function(w, i) {
      w.style.position      = 'fixed';
      w.style.inset         = '0';
      w.style.width         = '100%';
      w.style.height        = '100svh';
      w.style.margin        = '0';
      w.style.willChange    = 'opacity';
      /* Promover a capa GPU propia: evita el "cold paint" que dejaba
         la sección en blanco la primera vez que se mostraba */
      w.style.transform        = 'translateZ(0)';
      w.style.backfaceVisibility = 'hidden';
      w.style.zIndex        = i === 0 ? '2' : '1';
      if (i !== 0) {
        w.style.opacity       = '0';
        w.style.visibility    = 'hidden';
        w.style.pointerEvents = 'none';
      }
      /* Forzar layout + paint inmediato de cada sección */
      void w.offsetHeight;
    });

    function triggerReveals(wrapper) {
      /* Marca la sección como activa: dispara las animaciones de entrada
         vía CSS. El contenido es visible por defecto, así que si esto
         falla nunca queda en blanco. */
      wrappers.forEach(function(w) {
        if (w !== wrapper) w.classList.remove('fp-active');
      });
      void wrapper.offsetHeight;
      wrapper.classList.add('fp-active');

      /* Compatibilidad: secciones que aún usan .js-reveal/is-visible */
      wrapper.querySelectorAll('.js-reveal:not(.is-visible)').forEach(function(el) {
        var delay = parseInt(el.dataset.revealDelay) || 0;
        setTimeout(function() { el.classList.add('is-visible'); }, delay + 150);
      });
    }

    triggerReveals(wrappers[0]);

    /* Pausa/reanuda el WebGL + corazón 3D de la sección 1 según esté activa */
    var heart = document.querySelector('.threshold__heart');
    function updateThresholdViz(activeIndex) {
      var onThreshold = activeIndex === 0;
      if (window.__avThreshold) {
        if (onThreshold) window.__avThreshold.resume();
        else             window.__avThreshold.pause();
      }
      if (heart) {
        if (onThreshold) heart.setAttribute('auto-rotate', '');
        else             heart.removeAttribute('auto-rotate');
      }
    }

    function goTo(index) {
      if (isAnimating || index === current) return;
      if (index < 0 || index >= wrappers.length) return;

      isAnimating  = true;
      lastNavigate = Date.now();
      var from = wrappers[current];
      var to   = wrappers[index];

      if (reduced) {
        from.style.opacity       = '0';
        from.style.visibility    = 'hidden';
        from.style.zIndex        = '1';
        from.style.pointerEvents = 'none';
        to.style.visibility      = 'visible';
        to.style.opacity         = '1';
        to.style.zIndex          = '2';
        to.style.pointerEvents   = '';
        current = index; isAnimating = false;
        updateThresholdViz(index);
        triggerReveals(to);
        return;
      }

      overlay.classList.add('fp-overlay--visible');

      setTimeout(function() {
        /* Ocultar la saliente: detiene su render (WebGL, corazón, sparks)
           y libera el compositor para pintar la entrante */
        from.style.opacity       = '0';
        from.style.visibility    = 'hidden';
        from.style.zIndex        = '1';
        from.style.pointerEvents = 'none';
        /* Hacer visible la entrante y forzar su paint antes de mostrarla */
        to.style.visibility      = 'visible';
        void to.offsetHeight;
        to.style.zIndex          = '2';
        to.style.opacity         = '1';
        to.style.pointerEvents   = '';
        current = index;
        updateThresholdViz(index);
        triggerReveals(to);
        overlay.classList.remove('fp-overlay--visible');
        setTimeout(function() { isAnimating = false; }, 650);
      }, 450);
    }

    // Wheel
    window.addEventListener('wheel', function(e) {
      e.preventDefault();
      if (Date.now() - lastNavigate < COOLDOWN) return;
      /* Mismo criterio que en touch: un desplazamiento lateral de
         trackpad sobre el carrusel no debe cambiar de seccion. */
      if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
      if (e.deltaY > 3)      goTo(current + 1);
      else if (e.deltaY < -3) goTo(current - 1);
    }, { passive: false });

    /* Touch
       Se miden los DOS ejes. Antes solo se guardaba Y, asi que un swipe
       lateral (el carrusel de obras en movil) cambiaba de seccion en
       cuanto el dedo derivaba 50px en vertical — y derivar es inevitable.
       Solo se navega si el gesto es mas vertical que horizontal. */
    var touchStartX = 0;
    var touchStartY = 0;
    window.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    window.addEventListener('touchend', function(e) {
      if (Date.now() - lastNavigate < COOLDOWN) return;
      var diffY = touchStartY - e.changedTouches[0].clientY;
      var diffX = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diffX) >= Math.abs(diffY)) return;
      if (Math.abs(diffY) > 50) goTo(diffY > 0 ? current + 1 : current - 1);
    }, { passive: true });

    // Teclado
    window.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowDown' || e.key === 'PageDown') { e.preventDefault(); goTo(current + 1); }
      else if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); goTo(current - 1); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  /* ── WebGL: stream de estrellas cayendo (mismo shader que el hero) ── */
  (function() {
    var canvas = document.getElementById('coming-canvas');
    if (!canvas) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      canvas.style.display = 'none';
      return;
    }

    var P = {
      streamStartY: 0.0,
      coneW:        0.10,
      coneTaper:    0.8,
      fallFade:     2.2,
      fallSpeed:    0.18,
      fallGrid:     19.0,
      freqBase:     0.25,
      freqRange:    0.25,
      gateExp:      10.0,
      colorSpeed:   0.20,
      starSize:     70.0,
      starBright:   4.0,
    };

    function glf(n) { return Number.isInteger(n) ? n + '.0' : String(n); }

    var VERT = 'attribute vec2 pos; void main() { gl_Position = vec4(pos, 0.0, 1.0); }';

    var FRAG = `
      precision highp float;
      uniform vec2  iResolution;
      uniform float iTime;

      float hash(float n) { return fract(sin(n) * 43758.5453); }

      vec3 palette(float t) {
        vec3 a = vec3(0.600, 0.420, 0.480);
        vec3 b = vec3(0.420, 0.320, 0.420);
        vec3 c = vec3(1.000, 1.000, 0.800);
        vec3 d = vec3(0.000, 0.050, 0.560);
        return a + b * cos(6.28318 * (c * t + d));
      }

      void main() {
        vec2 uv = (gl_FragCoord.xy * 2.0 - iResolution.xy) / iResolution.y;

        float rawBelow  = ${glf(P.streamStartY)} - uv.y;
        float isBelow   = step(0.001, rawBelow);
        float belowDep  = max(rawBelow, 0.0);

        float coneW     = ${glf(P.coneW)} * exp(-belowDep * ${glf(P.coneTaper)});
        float coneMask  = exp(-uv.x * uv.x / max(coneW * coneW, 0.0001));
        float streamFade = exp(-belowDep * ${glf(P.fallFade)}) * coneMask * isBelow;

        vec2 fSUV  = vec2(uv.x, uv.y + iTime * ${glf(P.fallSpeed)});
        vec2 fCell = floor(fSUV * ${glf(P.fallGrid)});
        vec2 fLoc  = fract(fSUV * ${glf(P.fallGrid)}) - 0.5;

        float fh    = hash(fCell.x * 127.1 + fCell.y * 311.7);
        float fgate = pow(max(sin(iTime * (${glf(P.freqBase)} + fh * ${glf(P.freqRange)}) + fh * 6.2832), 0.0), ${glf(P.gateExp)});

        float fd   = length(fLoc);
        float fsh  = 300.0;
        float fsf  = 16.0;
        float fCore = exp(-fd * fd * ${glf(P.starSize)});
        float fSpH  = exp(-fLoc.y * fLoc.y * fsh) * exp(-abs(fLoc.x) * fsf);
        float fSpV  = exp(-fLoc.x * fLoc.x * fsh) * exp(-abs(fLoc.y) * fsf);
        float fLux  = fCore + (fSpH + fSpV) * 0.40;

        vec3 col = palette(fh + 0.35 + iTime * ${glf(P.colorSpeed)})
                 * fLux * fgate * streamFade * ${glf(P.starBright)};

        gl_FragColor = vec4(col, 1.0);
      }
    `;

    var gl = canvas.getContext('webgl', { antialias: false })
          || canvas.getContext('experimental-webgl', { antialias: false });

    if (!gl) return;

    function mkShader(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS))
        console.error('Shader error:', gl.getShaderInfoLog(s));
      return s;
    }

    var prog = gl.createProgram();
    gl.attachShader(prog, mkShader(gl.VERTEX_SHADER,   VERT));
    gl.attachShader(prog, mkShader(gl.FRAGMENT_SHADER, FRAG));
    gl.linkProgram(prog);
    gl.useProgram(prog);

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
      -1,-1,  1,-1,  -1, 1,
       1,-1,  1, 1,  -1, 1
    ]), gl.STATIC_DRAW);

    var posLoc = gl.getAttribLocation(prog, 'pos');
    gl.enableVertexAttribArray(posLoc);
    gl.vertexAttribPointer(posLoc, 2, gl.FLOAT, false, 0, 0);

    var uRes  = gl.getUniformLocation(prog, 'iResolution');
    var uTime = gl.getUniformLocation(prog, 'iTime');

    function resize() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width  = Math.round(canvas.offsetWidth  * dpr);
      canvas.height = Math.round(canvas.offsetHeight * dpr);
      gl.viewport(0, 0, canvas.width, canvas.height);
    }

    var t0 = performance.now();

    function loop() {
      var t = (performance.now() - t0) * 0.001;
      gl.uniform2f(uRes,  canvas.width, canvas.height);
      gl.uniform1f(uTime, t);
      gl.drawArrays(gl.TRIANGLES, 0, 6);
      requestAnimationFrame(loop);
    }

    resize();
    window.addEventListener('resize', resize);
    loop();
  })();

  /* ── Gate de contraseña: estrella ↔ panel ── */
  (function() {
    var star  = document.getElementById('coming-star');
    var gate  = document.getElementById('coming-gate');
    var close = document.getElementById('coming-gate-close');
    if (!star || !gate) return;

    function open() {
      gate.hidden = false;
      star.setAttribute('aria-expanded', 'true');
      var input = document.getElementById('coming-password');
      if (input) input.focus();
    }

    function shut() {
      gate.hidden = true;
      star.setAttribute('aria-expanded', 'false');
      star.focus();
    }

    star.addEventListener('click', function() {
      if (gate.hidden) open(); else shut();
    });

    if (close) close.addEventListener('click', shut);

    gate.addEventListener('click', function(e) {
      if (e.target === gate) shut();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !gate.hidden) shut();
    });

    /* Si el envío de contraseña falló, abrir el gate para mostrar el error */
    if (gate.querySelector('.coming__gate-error')) open();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function () {
  let activeIndex = 0;

  const slides = () => document.querySelectorAll('.product__main-slide');
  const thumbs = () => document.querySelectorAll('.product__thumb');

  function goTo(index) {
    const s = slides(), t = thumbs();
    if (index < 0 || index >= s.length) return;
    s.forEach((el, i) => el.classList.toggle('product__main-slide--active', i === index));
    t.forEach((el, i) => el.classList.toggle('product__thumb--active', i === index));
    activeIndex = index;
  }

  function openLightbox() {
    const active = slides()[activeIndex];
    const lightbox = document.getElementById('product-lightbox');
    const lightboxImg = document.getElementById('product-lightbox-img');
    if (!active || !lightbox || !lightboxImg) return;
    const img = active.querySelector('img');
    if (!img) return;
    lightboxImg.innerHTML = '';
    const clone = img.cloneNode();
    clone.removeAttribute('loading');
    clone.style.maxWidth  = '90vw';
    clone.style.maxHeight = '90svh';
    clone.style.objectFit = 'contain';
    lightboxImg.appendChild(clone);
    lightbox.showModal();
  }

  // Delegacion en document: sobrevive al re-render de la seccion (editor de Shopify)
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('.product__thumb');
    if (thumb) { goTo(Number(thumb.dataset.index)); return; }
    if (e.target.closest('#product-zoom-btn')) { openLightbox(); return; }
    if (e.target.closest('.product__lightbox-close')) {
      document.getElementById('product-lightbox')?.close();
      return;
    }
    if (e.target.id === 'product-lightbox') e.target.close();
  });

  // Swipe en movil
  let touchStartX = 0;
  document.addEventListener('touchstart', (e) => {
    if (e.target.closest('#product-main-image')) touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  document.addEventListener('touchend', (e) => {
    if (!e.target.closest('#product-main-image')) return;
    const delta = e.changedTouches[0].screenX - touchStartX;
    if (Math.abs(delta) < 40) return;
    const total = slides().length;
    if (delta < 0 && activeIndex < total - 1) goTo(activeIndex + 1);
    if (delta > 0 && activeIndex > 0) goTo(activeIndex - 1);
  }, { passive: true });
})();

/* ── Selector de variantes ─────────────────────────────────── */
(function () {
  const form = document.getElementById('product-form');
  if (!form) return;

  const jsonEl = document.getElementById('product-variants-json');
  let variants = [];
  try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

  const selects     = form.querySelectorAll('.product__option-select');
  const idInput     = document.getElementById('product-variant-id');
  const submit      = document.getElementById('product-submit');
  const submitText  = document.getElementById('product-submit-text');
  const priceEl     = document.getElementById('product-price');

  // Variante única (default) → el estado renderizado en servidor ya es correcto
  if (selects.length === 0) return;

  function selectedOptions() {
    return Array.from(selects).map((s) => s.value);
  }

  function matchVariant(opts) {
    return variants.find((v) =>
      v.options.length === opts.length &&
      v.options.every((o, i) => o === opts[i])
    );
  }

  function renderPrice(v) {
    if (!priceEl) return;
    let html = '';
    if (v.compare_at_raw > v.price_raw && v.compare_at_price) {
      html += '<span class="product__price--compare">' + v.compare_at_price + '</span>';
    }
    html += '<span class="product__price--current">' + v.price + '</span>';
    priceEl.innerHTML = html;
  }

  function update() {
    const v = matchVariant(selectedOptions());
    if (!v) {
      idInput.value = '';
      submit.disabled = true;
      submitText.textContent = submit.dataset.unavailable;
      return;
    }
    idInput.value = v.id;
    renderPrice(v);
    if (v.available) {
      submit.disabled = false;
      submitText.textContent = submit.dataset.add;
    } else {
      submit.disabled = true;
      submitText.textContent = submit.dataset.soldOut;
    }
  }

  selects.forEach((s) => s.addEventListener('change', update));
  update();
})();

  } catch(e) { console.error(e); }
})();
})();
